import {Container} from "../../components/LayoutHelpers";
import {Compa} from "../../components/Compa";
import React from "react";
import {SITE} from "../../constants/SITE";
import "./Footer.css"

export default function Footer() {
    return <footer className="footer" role="contentinfo">
        <Container className="footer-grid">
            <div className="footer-brand">
                <Compa size={40}/>
                <div>
                    <div className="brand-title">COMPASSIA</div>
                    <div className="muted small">© {new Date().getFullYear()} – Todos los derechos reservados</div>
                </div>
            </div>
            <div className="footer-col">
                <div className="h4">Contacto</div>
                <div><a className="link-muted" href={`mailto:${SITE.email}`}>{SITE.email}</a></div>
                <div className="muted">{SITE.city}, {SITE.country}</div>
            </div>
            <div className="footer-col">
                <div className="h4">Legal</div>
                <div><a href="/aviso-legal" className="link-muted">Aviso legal</a></div>
                <div><a href="/politica-privacidad" className="link-muted">Política de privacidad</a></div>
                <div><a href="/cookies" className="link-muted">Cookies</a></div>
            </div>
        </Container>
    </footer>
}